import axios from 'axios';
import router from "../router";

const Host = ''   //正式环境域名
// 创建一个 axios 实例
const MyHttpServer = axios.create({
  baseURL:  Host + '', // 你的 API 基本 URL
  // 其他 axios 配置...
});

// 添加请求拦截器
MyHttpServer.interceptors.request.use(
  function (config)  {
    // 在发送请求之前做些什么
    // 例如，添加认证 token 到 headers
    if (localStorage.getItem('token')) {
      config.headers["token"] = localStorage.getItem("token")
      config.headers['Admin-Token'] = `${localStorage.getItem('token')}`;
    }
    // if (localStorage.getItem('token')) {
    //   config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    // }
    return config;
  },
 function (error)  {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
// MyHttpServer.interceptors.response.use(
// response => {
//     // 对响应数据做点什么
//     return response.data; // 假设服务器返回的是 { data: ..., status: ..., message: ... } 这种结构，并且你只需要 data
//   },
//   error => {
//     // 对响应错误做点什么
//     if (error.response) {
//       // 请求已发出，但服务器响应的状态码不在 2xx 范围内
//       console.error('Error from server:', error.response.data);
//       console.log(error.response.data,'登录拦截');
//       if (error.response.data.login_state == "error") {
//         router.push("/login");
//       }
//       return Promise.reject(error.response.data);
//     } else if (error.request) {
//       // 请求已发出，但没有收到响应
      
//       console.error('No response from server', error.request);
//     } else {
//       // 发送请求时发生了某些错误
//       console.error('Error', error.message);
//     }
//     return Promise.reject(error);
//   }
// );
// 导出这个 axios 实例
export default MyHttpServer;